/*
 * @Description: 
 * @Date: 2025-09-01 10:22:20
 * @LastEditTime: 2026-09-18 15:00:41
 * @FilePath: \hui_ai_ui\src\main.js
 */
// 屏蔽 ResizeObserver loop 警告（Element UI 组件开合时浏览器触发）
const _resizeObserverErrorMsg = 'ResizeObserver loop completed with undelivered notifications';
window.addEventListener('error', function (e) {
  if (e.message && e.message.includes(_resizeObserverErrorMsg)) {
    e.stopImmediatePropagation();
  }
});

// ⚠️ 关键：必须在所有其他 import 之前加载 tauri.js
// 因为它会 hook axios.create，确保所有后续 axios 实例自动使用 Tauri HTTP 适配器
// 绕过 WebView 的 CORS 限制
import './api/tauri';

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
Vue.config.productionTip = false
import ElementUI from 'element-ui';

import { setSessionStorage, getSessionStorage, deleteSessionStorage } from './utils/auth'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/style/fontcss.css'
import './assets/style/msgBoxGlobal.css'
import './assets/style/markdown-table-fix.css'
import './utils/dialogDrag.js'

// 解决mousewheel事件passive警告问题 - 带浏览器兼容性检测
// 检测浏览器是否支持passive事件监听器
function supportPassive() {
  var supportsPassive = false;
  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function() {
        supportsPassive = true;
      }
    });
    window.addEventListener('testPassive', null, opts);
    window.removeEventListener('testPassive', null, opts);
  } catch (e) {}
  return supportsPassive;
}

// 覆盖addEventListener方法以自动处理passive事件
const originalAddEventListener = EventTarget.prototype.addEventListener;
EventTarget.prototype.addEventListener = function(type, listener, options) {
  // 处理滚动阻塞事件：wheel, mousewheel, touchmove
  if (['wheel', 'mousewheel', 'touchmove'].includes(type) && supportPassive()) {
    // 如果options是布尔值，转换为对象
    if (typeof options === 'boolean') {
      options = { capture: options };
    }
    // 如果options是对象，确保passive为true
    if (typeof options === 'object' && options !== null) {
      options.passive = options.passive !== false;
    } else {
      options = { passive: true };
    }
  }
  return originalAddEventListener.call(this, type, listener, options);
};

Vue.prototype.$setSessionStorage = setSessionStorage
Vue.prototype.$getSessionStorage = getSessionStorage
Vue.prototype.$deleteSessionStorage = deleteSessionStorage
Vue.use(ElementUI);

import { install as XFrameDetectorInstall } from './utils/iframe-xframe-detector.js';
Vue.use(XFrameDetectorInstall);

// 注册 Tauri window.open 重写
import { initTauriOpenUrl } from './utils/tauri-open-url';
initTauriOpenUrl();

// 注册.it_source元素点击事件处理指令
import { registerSourceClickDirective } from './utils/sourceClickDirective';
registerSourceClickDirective(Vue);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
